import * as types from '../actions/action-types';

const initialState = {
  zoomLink: '',
};

const zoomReducer = function (state = initialState, action) {
    if (action.type === types.ZOOM_MSG) {
      return Object.assign({}, state, {zoomLink: action.zoomLink});
    }
    return state;

}

export default zoomReducer;



/** WEBPACK FOOTER **
 ** ./src/client/app/reducers/zoom-reducer.js
 **/